import tw from 'twin.macro';

export const PageWrapper = tw.div`overflow-hidden py-12 relative`;

export const SortSpan = tw.span`text-base cursor-pointer p-3 flex items-center justify-center
text-gray-600 w-7 px-3 rounded-lg bg-gray-100 ml-2 `;

export const SortIcon = tw.i`m-auto`;

export const SheetsWrap = tw.div`mt-12 pb-8 grid grid-cols-3 gap-12`;

export const AttendantSheetCard = tw.div`bg-gray-200 flex flex-col items-center rounded-md py-6`;

export const Image = tw.img`w-72 2xl:w-96 object-center mx-auto object-contain h-48`;

export const CardText = tw.div`text-center my-3 text-gray-700`;

export const CourseCode = tw.h4`text-2xl font-medium`;

export const CourseName = tw.h5`font-thin`;

export const ClassName = tw.h6`font-thin`;

export const CardActions = tw.div`flex items-center`;

export const ViewButton = tw.button`px-14 py-1 rounded-md font-semibold bg-blue-600 text-white`;

export const PrintButton = tw.button`text-3xl p-2 rounded-xl ml-14 bg-green-600 text-white`;

export const Pagination = tw.div`float-right justify-between text-2xl flex items-center`;

export const PaginationIcon = tw.i`mx-2 text-gray-700`;
